import React, { useState } from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingComponent from '../../components/ListingComponent.js';
import FiltersPartial from './FiltersPartial.js';

const Listing = (props) => {
  const [filtersModel, setFiltersModel] = useState({...props.params});

  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Benificiary',
      value: (row) => {
        return <div className='d-block'>
          <div>
          ( {row.benifitiary_nomenclateure_id} ) -
          {row.benificiary_name} 
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer',
      value: (row) => {
        return <div className='d-block'>
          <div>
          ( {row.customer_nomenclature_id} ) -
          {row.customer_name}
            
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer Name',
      attr: 'offer_name',
      disableSort: true
    },

    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'CS serial no',
      attr: 'charging_station_serial_no',
      disableSort: true
    },    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    // {
    //   ...defaultHeaderConfig,
    //   label: 'Activated at',
    //   attr: 'activated_at',
    //   disableSort: false
    // },
    // {
    //   disableSort: false,
    //   label: 'Actions',
    //   value: (row) => {
    //     return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    //       <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_distributor_list.name)}>
    //         <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
    //           <FontAwesomeIcon icon={faEye} />
    //         </div>
    //       </UiAction>
    //     </div>
    //   }
    // }
  ]

  return <ListingComponent
    // key={PAGES.EarningsListingPage.name}
    // uiPage={uiManager.getUiPage(PAGES.EarningsListingPage.name)}
    // breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Earnings' }]}
    listingMutation={getApi('earnings')}
    className="earnings_listing-page"
    contentHeading="Earnings - Results"
    headers={headers}
    recordsKey="earnings"
    filtersModel={filtersModel}
    filters={
      !!!props.hideFilter && <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['Benificiary ID']}
  />
};

export default Listing;

